<div class="row justify-content-center">
  <div class="d-flex flex-row col-10 mt-5 px-0">
    <div class="d-flex flex-row ms-auto align-items-center">
      @if (!anyChanges) {
        <div class="my-4"></div>
      }
      <div class="d-flex flex-row flex-grow-1">
        @if (toBeDeployed.length > 0) {
          <p class="mx-3 mb-0" id="summary-to-be-deployed">
            <strong class="pe-2 d-inline-block">Deploy:</strong>
            <span class="d-inline-block">
              {{ toBeDeployed[0].actor.actorName | removeParentActor: toBeDeployed[0].parentOrg?.actorName }}
            </span>
            @if (toBeDeployed.length > 1) {
              <span
                [ngbTooltip]="toBeDeployed | slice: 1 | joinEntities"
                class="mx-2 more-entities d-inline-block"
                id="summary-to-be-deployed-more">
                + {{ toBeDeployed.length - 1 }} more
              </span>
            }
          </p>
        }
        @if (toBeDeployed.length > 0 && toBeUndeployed.length > 0) {
          <div
            role="separator" aria-orientation="vertical" class="vertical-separator height-inherit">
          </div>
        }
        @if (toBeUndeployed.length > 0) {
          <p class="mx-3 mb-0" id="summary-to-be-undeployed">
            <strong class="pe-2 d-inline-block">Undeploy:</strong>
            <span class="d-inline-block">
              {{ toBeUndeployed[0].actor.actorName |
              removeParentActor: toBeUndeployed[0].parentOrg?.actorName }}
            </span>
            @if (toBeUndeployed.length > 1) {
              <span
                [ngbTooltip]="toBeUndeployed | slice: 1 | joinEntities"
                class="mx-2 more-entities d-inline-block"
                id="summary-to-be-undeployed-more">
                + {{ toBeUndeployed.length - 1 }} more
              </span>
            }
          </p>
        }
        @if (toBeDeployed.length + toBeUndeployed.length > 0 && toBeExcluded.length + toBeUnexcluded.length> 0) {
          <div
            role="separator" aria-orientation="vertical" class="vertical-separator height-inherit">
          </div>
        }
        @if (toBeExcluded.length > 0) {
          <p class="mx-3 mb-0" id="summary-to-be-excluded">
            <strong class="pe-2 d-inline-block">Exclude:</strong>
            <span class="d-inline-block">
              {{ toBeExcluded[0].actor.actorName | removeParentActor: toBeExcluded[0].parentOrg?.actorName }}
            </span>
            @if (toBeExcluded.length > 1) {
              <span
                [ngbTooltip]="toBeExcluded | slice: 1 | joinEntities"
                class="mx-2 more-entities d-inline-block"
                id="summary-to-be-excluded-more">
                + {{ toBeExcluded.length - 1 }} more
              </span>
            }
          </p>
        }
        @if (toBeExcluded.length > 0 && toBeUnexcluded.length> 0) {
          <div
            role="separator" aria-orientation="vertical" class="vertical-separator height-inherit">
          </div>
        }
        @if (toBeUnexcluded.length > 0) {
          <p class="mx-3 mb-0" id="summary-to-be-unexcluded">
            <strong class="pe-2 d-inline-block">Unexclude:</strong>
            <span class="d-inline-block">
              {{ toBeUnexcluded[0].actor.actorName |
              removeParentActor: toBeUnexcluded[0].parentOrg?.actorName }}
            </span>
            @if (toBeUnexcluded.length > 1) {
              <span
                [ngbTooltip]="toBeUnexcluded | slice: 1 | joinEntities"
                class="mx-2 more-entities d-inline-block"
                id="summary-to-be-unexcluded-more">
                + {{ toBeUnexcluded.length - 1 }} more
              </span>
            }
          </p>
        }
        @if (toRemoveOverrides.length > 0) {
          <div
            role="separator" aria-orientation="vertical" class="vertical-separator height-inherit">
          </div>
        }
        @if (toRemoveOverrides.length > 0) {
          <p class="mx-3 mb-0" id="summary-to-remove-overrides">
            <strong class="pe-2 d-inline-block">Remove overrides:</strong>
            <span class="d-inline-block">
              {{ toRemoveOverrides[0].actor.actorName |
              removeParentActor: toRemoveOverrides[0].parentOrg?.actorName }}
            </span>
            @if (toRemoveOverrides.length > 1) {
              <span
                [ngbTooltip]="toRemoveOverrides | slice: 1 | joinEntities"
                class="mx-2 more-entities d-inline-block"
                id="summary-to-remove-overrides-more">
                + {{ toRemoveOverrides.length - 1 }} more
              </span>
            }
          </p>
        }

      </div>
    </div>
  </div>
  <div class="d-flex flex-row col-10 mt-5 px-0">
    @if (anyChanges) {
      <button
        class="btn btn-outline-primary mx-5 justify-content-center align-items-center ms-auto"
        id="cancel-btn"
        (click)="cancel()"
        >
        Cancel
      </button>
    }
    <button
      class="btn btn-primary justify-content-center align-items-center"
      [class.ms-auto]="!anyChanges"
      id="deploy-btn"
      (click)="apply()"
      [disabled]="!anyChanges"
      >
      Apply
    </button>
  </div>
</div>
